// Routes
export const PRL_ROUTE_SESSION_PLANNING = "prl/sessionPlanning";
export const PRL_ROUTE_SESSION_PLANNING_FORM = "prl/sessionPlanning/form";
export const PRL_ROUTE_ATTENDANCE = "prl/attendance";
export const PRL_ROUTE_ATTENDANCE_FORM = "prl/attendance/form";
export const PRL_ROUTE_EXECUTION = "prl/execution";
export const PRL_ROUTE_EXECUTION_FORM = "prl/execution/form";
export const PRL_ROUTE_SUPERVISION = "prl/supervision";
export const PRL_ROUTE_SUPERVISION_FORM = "prl/supervision/form";
export const PRL_ROUTE_FAMILY_GROUP = "prl/familyGroup";
export const PRL_ROUTE_FAMILY_GROUP_FORM = "prl/familyGroup/form";
export const PRL_ROUTE_EDUCATIONAL_MODULE = "prl/educationalModule";
export const PRL_ROUTE_EDUCATIONAL_MODULE_FORM = "prl/educationalModule/form";
export const PRL_ROUTE_BIMONTHLY_REPORT = "prl/bimonthlyReport";
export const PRL_ROUTE_BIMONTHLY_REPORT_FORM = "prl/bimonthlyReport/form";
export const PRL_ROUTE_BIMONTHLY_SUPERVISION = "prl/bimonthlySupervision";
export const PRL_ROUTE_BIMONTHLY_SUPERVISION_FORM = "prl/bimonthlySupervision/form";
export const PRL_ROUTE_SUPERVISION_REPORT = "prl/supervisionReport";
export const PRL_ROUTE_SUPERVISION_REPORT_FORM = "prl/supervisionReport/form";
export const PRL_ROUTE_ALUNO = "prl/alunos";
export const PRL_ROUTE_ALUNO_FORM = "prl/alunos/form";

// Module Name
export const MODULE_NAME = "prl";

export const RIGHT_ALUNO_MANAGE = 159061;
export const RIGHT_ALUNO_DELETE = 159062;

// Encaminhamentos
export const PRL_ROUTE_ENCAMINHAMENTOS = "prl/encaminhamentos";
export const PRL_ROUTE_ENCAMINHAMENTOS_FORM = "prl/encaminhamentos/form";

// Status
export const SESSION_STATUS = {
  PLAN: "PLAN",
  EXEC: "EXEC",
  CONC: "CONC",
  CANC: "CANC",
};
